interface ModeServiceType {
    currentMode: string | null;
    getMode: () => Promise<string | null>;
    setMode: (mode: string) => Promise<void>;
    getModeFr: () => Promise<string | null>;
  }
  
  const ModeService: ModeServiceType = {
    currentMode: null,
  
    getMode: async () => {
      try {
        const storedMode = localStorage.getItem('mode');
        ModeService.currentMode = storedMode;
        if(!ModeService.currentMode) ModeService.setMode('seeker');
        return storedMode;
      } catch (error) {
        console.error('Error retrieving mode from localStorage:', error);
        return null;
      }
    },
  
    setMode: async (mode: string) => {
      try {
        localStorage.setItem('mode', mode);
        ModeService.currentMode = mode;
      } catch (error) {
        console.error('Error setting mode in localStorage:', error);
      }
    },
  
    getModeFr: async () => {
      if (!ModeService.currentMode) {
        await ModeService.getMode();
      }
      return ModeService.currentMode;
    }
  };
  
  export default ModeService;
  